import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';

export class UIActionSelectEvent {
    target: HTMLElement;
    index: number;
}

@Component({
  // tslint:disable-next-line:component-selector
    selector: 'ui-action',
    templateUrl: './ui-action.component.html'
})
export class UIActionComponent implements AfterViewInit {
    @ViewChild('action') action: ElementRef<HTMLDivElement>;
    @Input() group: string;
    @Input() value: any;
    @Output() valueChange = new EventEmitter();
    @Output() onSelect: EventEmitter<UIActionSelectEvent> = new EventEmitter();

    ngAfterViewInit(): void {
        if (this.group) {
            this.action.nativeElement.setAttribute('data-group', this.group);
        }
        this.action.nativeElement.setAttribute('data-value', this.value);
    }

    select(event: MouseEvent): void {
        event.preventDefault();
        this.onSelect.emit({
            target: (event.currentTarget as HTMLElement).parentElement,
            index: Array.from((event.currentTarget as HTMLElement).parentElement.parentElement.children)
              .findIndex(el => el === (event.currentTarget as HTMLElement).parentElement)
        });
        this.valueChange.emit(this.value);
        (document.activeElement as HTMLElement).blur();
    }
}
